import config from './config';

const {
  blackCardDomain,
  fanxianDomain,
  domain,
  adDomain,
  blindBoxDomain,
  owaimai,
  facadeDomain,
  wechatApiDomain,
} = config;
export default {
  common: {
    getEntry: `${blackCardDomain}/advertise/get-entry`,
    getFanxianConfig: `${fanxianDomain}/api/public/getValues`,
    getTishenVersion: `${domain}/api/knightCard/wechat/coupon/v1_0/version`,
    getAllABtest: `${fanxianDomain}/abtest/v1/all`,
    getAD: `${adDomain}/advertise/v1/get`,
    authorized: `${blindBoxDomain}/promo-bargain-api/common/auth/v1_0/authorized`,
    getAuthorized: `${blindBoxDomain}/api/activity/bbox/api/userAuthorize`,
    cancelPay: `${blindBoxDomain}/api/cashier/v1_0/payinfo/cancel`,
    login: `${owaimai}/qskUser/v1/unionLogin`,
    // 根据骑士商城token获取box-token
    tokenChange: `${blindBoxDomain}/api/bbox/app/user/v1/token`,
    // 获取骑士卡用户id
    getMemberIdByUserId: `${blindBoxDomain}/api/user/bbox/v1/getMemberIdByUserId`,
    // 第三方联登接口 通过渠道、手机号获取用户token
    uniteLogin: `${blindBoxDomain}/api/user/bbox/v1/uniteLogin`,
  },
  user: {
    // 获取用户团长信息
    getLeaderInfo: `${blackCardDomain}/agent-leader/member-level`,
    // // 检测用户淘宝授权
    // checkTaobaoAuth: `${domain}/api/knightCard/sqb/v1_0/check`,
    // 检测用户拼多多授权
    checkPddAuth: `${fanxianDomain}/api/duoduoke/v1_0/authority/query`,
    // 小程序静默登录(openId)

    login: `${config.wechatApiDomain}/wechat/miniprogram/user/v1/login`,
    // 小程序通过解密手机号静默注册: 检测是否登录注册并返回 javaToken, phpToken,
    wxPhoneLoginAndRegister: `${
      config.facadeDomain
    }/mini/user/v1/registerForMini`,

    // checkIsBlackUserAndRegister: `${config.blindBoxDomain}/api/common/auth/v1_0/checkIsBlackUserAndRegister`,
    // 获取javaToken
    // getJavaToken: `${domain}/api/knightCard/user/v1_0/getAppToken`,
    // getPhpToken: `${config.blindBoxDomain}/api/miniwechat/phone-login`,
    // 储存订阅推送
    savePushAuth: `${blackCardDomain}/miniwechat/wx-mini-recall-auth`,
    // 获取用户返现信息
    getRebateSummary: `${
      config.fanxianDomain
    }/api/commission/v1_0/rebate/summary`,

    checkMemberCardByOpenid: `${
      config.facadeDomain
    }/mini/index/v1/backgroundContent`,
    wxMemberCardExt: `${config.facadeDomain}/memberCard/v1/getCardExt`,
    getCartNumber: `${domain}/api/knightCard/cart/v1_0/count`,
    setMarketChannel: `${blindBoxDomain}/api/activity/bbox/api/recordUserSource`,
  },
  coupon: {
    cardCouponReceive: `${blackCardDomain}/shop/coupon/pick`,
    shopCouponReceive: `${domain}/api/knightCard/coupon/v1_0/receiveCoupon`,
    miniReceiverCoupon: `${domain}/api/knightCard/coupon/v1_0/miniReceiverCoupon`, // 关联商家券
    getMerchantCouponConfig: `${domain}/api/knightCard/wechat/coupon/merchant/v1_0/receive`, // 商家券配置
    reportMerchantCouponResult: `${domain}/api/knightCard/wechat/coupon/merchant/receive/v1_0/result`, // 上报领券结果
  },
  myBox: {
    myBlindBoxList: `${blindBoxDomain}/api/activity/bbox/api/listUserGoods`,
    recoverCalculate: `${blindBoxDomain}/api/activity/bbox/api/recoverCalculate`,
    batchRecovery: `${blindBoxDomain}/api/activity/bbox/api/batchRecovery`,
    deliveryCalculate: `${blindBoxDomain}/api/activity/bbox/api/deliveryCalculate`,
    batchDelivery: `${blindBoxDomain}/api/activity/bbox/api/batchDelivery`,
    orderCreate: `${blindBoxDomain}/api/cashier/v1_0/payinfo/orderCreate`,
    logisticsDetail: `${blindBoxDomain}/api/activity/bbox/api/logisticsDetail`,
    checkUserHasRecycled: `${blindBoxDomain}/api/activity/bbox/api/checkUserHasRecycled`,
    orderDetailInfo: `${blindBoxDomain}/api/activity/bbox/api/orderDetailInfo`,
    listUnOpenOrderList: `${blindBoxDomain}/api/activity/bbox/api/listUnOpenOrderList`,
  },
  address: {
    getDefaultlAddress: `${domain}/api/knightCard/address/v1_0/user/query_default`,
    needToUpdateAddress: `${domain}/api/knightCard/address/v1_0/user/needToUpdateAddress`,
    getAddress: `${domain}/api/knightCard/address/v1_0/user/get`,
    defaultAddress: `${domain}/api/knightCard/address/v1_0/user/set_default`,
    getAreaData: `${domain}/api/knightCard/address/v1_0/getAddress`,
    saveAddress: `${domain}/api/knightCard/address/v1_0/user/add`,
    editAddress: `${domain}/api/knightCard/address/v1_0/user/modify`,
    deleAddress: `${domain}/api/knightCard/address/v1_0/user/delete`,
    // getBlackUniqueUserInfo: `${blackCardDomain}/common/get-user-info`,
    getBlackUniqueUserInfo: `${facadeDomain}/user/common/v1/getUserInfo`,
    getDeliverNote: `${blindBoxDomain}/api/activity/bbox/api/getDeliverNote`,
    isExistWaitDeliverOrder: `${blindBoxDomain}/api/activity/bbox/api/isExistWaitDeliverOrder`,
  },
  // 主页
  entry: {
    getBlindGoodsList: `${blindBoxDomain}/api/activity/bbox/api/bboxList`,
    sendInitialRecycleCard: `${blindBoxDomain}/api/activity/bbox/api/sendInitialRecycleCard`,
    barrageData: `${blindBoxDomain}/api/activity/bbox/api/barrageData`,
    helpForRecycleCard: `${blindBoxDomain}/api/activity/bbox/api/helpForRecycleCard`,
    ifShowArraign: `${blindBoxDomain}/api/activity/bbox/api/underWxAudit`,
    readInitialCard: `${blindBoxDomain}/api/activity/bbox/api/readInitialCard`,
  },
  detail: {
    getBlindGoodsDetail: `${blindBoxDomain}/api/activity/bbox/api/bboxDetailInfo`,
    createOrder: `${blindBoxDomain}/api/activity/bbox/api/batchCreateOrder`,
    payProgress: `${blindBoxDomain}/api/cashier/v1_0/payinfo/deductionProgress`,
    openNormalBox: `${blindBoxDomain}/api/activity/bbox/api/openNormalBbox`,
    openPromoteBox: `${blindBoxDomain}/api/activity/bbox/api/openPromoteBbox`,
    userRecycleCardNum: `${blindBoxDomain}/api/activity/bbox/api/selectUserRecycleCardNum`,
    getBboxShareMark: `${blindBoxDomain}/api/activity/bbox/api/getBboxShareMark`,
    subscribe: `${blindBoxDomain}/api/activity/bbox/api/subscribe`,
    getRecycleCardConfig: `${blindBoxDomain}/api/activity/bbox/api/getRecycleCardConfig`,
    patternRateInfo: `${blindBoxDomain}/api/activity/bbox/api/patternRateInfo`,
    getBoxDiscountInfo: `${blindBoxDomain}/api/activity/bbox/api/getBoxDiscountInfo`,
    openPentaKillBox: `${blindBoxDomain}/api/activity/bbox/api/openBboxList`,
  },
  // 我的
  mine: {
    userInfo: `${blindBoxDomain}/api/activity/bbox/api/userInfo`,
    listRecycleCard: `${blindBoxDomain}/api/activity/bbox/api/listRecycleCard`,
    listUserGoldLog: `${blindBoxDomain}/api/activity/bbox/api/listUserGoldLog`,
  },
  // 余额
  balance: {
    userAuth: `${blindBoxDomain}/api/activity/bbox/api/userAuth`, // 实名认证
    withdrawCash: `${blindBoxDomain}/api/activity/bbox/api/withdrawCash`,
    userWalletInfo: `${blindBoxDomain}/api/activity/bbox/api/userWalletInfo`,
    listUserWithdrawApply: `${blindBoxDomain}/api/activity/bbox/api/listUserWithdrawApply`, // 提现列表
    listUserWalletFlow: `${blindBoxDomain}/api/activity/bbox/api/listUserWalletFlow`, // 钱包流水
    userInfo: `${blindBoxDomain}/api/activity/bbox/api/userInfo`,
    listRecycleCard: `${blindBoxDomain}/api/activity/bbox/api/listRecycleCard`,
    listUserGoldLog: `${blindBoxDomain}/api/activity/bbox/api/listUserGoldLog`,
    listUserWithdrawDetail: `${blindBoxDomain}/api/activity/bbox/api/listUserWithdrawDetail`,
  },
  // 登录接口
  login: {
    gtRegister: `${blindBoxDomain}/api/bbox/app/user/gt/v1/register`,
    imgCaptcha: `${blindBoxDomain}/api/bbox/app/user/gt/v1/imgCaptcha`,
    sendSms: `${blindBoxDomain}/api/bbox/app/user/v1/sendCaptcha`,
    smsLogin: `${blindBoxDomain}/api/bbox/app/user/v1/smsLogin`,
  },
  // 微信支付接口
  wxPay: {
    getWxAppId: `${blindBoxDomain}/api/activity/bbox/api/bboxBindingWxPublicId`,
    // getRedirectUrl: `${wechatApiDomain}/mp/authorization/v1/getBaseAuthorizationUrl`,
    getRedirectUrl: 'https://wechat-api.black-unique.com/mp/authorization/v1/getBaseAuthorizationUrl',
    getOpenId: 'https://wechat-api.black-unique.com/mp/authorization/v1/getOpenId',
    getWxConfig: 'https://wechat-api.black-unique.com/mp/js/v1/getJsApiSignature',
    // getWxConfig: `${wechatApiDomain}/mp/js/v1/getJsApiSignature`,
    // getOpenId: `${wechatApiDomain}/mp/authorization/v1/getOpenId`,
  },
  // 账号管理
  account: {
    singleLogout: `${blindBoxDomain}/api/bbox/app/user/v1/singleLogout`,
    cancalAccount: `${blindBoxDomain}/api/bbox/app/user/v1/log/out`,
  },
  // 道具卡
  luckyCard: {
    listItemCardUser: `${blindBoxDomain}/api/activity/bbox/api/listItemCardUser`,
    receiveSohCard: `${blindBoxDomain}/api/activity/bbox/api/receiveSohCard`,
  },
  // 消费总览
  orderRecords: {
    userConsumerInfo: `${blindBoxDomain}/api/activity/bbox/api/userConsumerInfo`,
    listUserOrderInfo: `${blindBoxDomain}/api/activity/bbox/api/listUserOrderInfo`,
  },
};
